import React, { useState, useRef } from 'react';
import { beforeAfter } from '../mock';

const BeforeAfter = () => {
  const [pos, setPos] = useState(50);
  const ref = useRef(null);
  const dragging = useRef(false);

  const handleMove = (clientX) => {
    if (!ref.current) return;
    const rect = ref.current.getBoundingClientRect();
    const x = Math.max(0, Math.min(clientX - rect.left, rect.width));
    setPos((x / rect.width) * 100);
  };

  return (
    <section className="py-20 md:py-24 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="font-display text-3xl md:text-5xl font-bold text-center text-brand-navy uppercase title-underline">
          I Nostri Clienti sono Soddisfatti
        </h2>

        <div className="mt-14 grid lg:grid-cols-3 gap-10 items-center">
          <div className="lg:col-span-2">
            <div
              ref={ref}
              className="before-after-wrap rounded-xl shadow-2xl aspect-[16/10] bg-gray-200 cursor-ew-resize select-none"
              onMouseDown={(e) => { dragging.current = true; handleMove(e.clientX); }}
              onMouseMove={(e) => { if (dragging.current) handleMove(e.clientX); }}
              onMouseUp={() => (dragging.current = false)}
              onMouseLeave={() => (dragging.current = false)}
              onTouchStart={(e) => { dragging.current = true; handleMove(e.touches[0].clientX); }}
              onTouchMove={(e) => { if (dragging.current) handleMove(e.touches[0].clientX); }}
              onTouchEnd={() => (dragging.current = false)}
            >
              <img src={beforeAfter.after} alt="Dopo" loading="lazy" decoding="async" width="1200" height="800" className="absolute inset-0 w-full h-full object-cover" />
              <div className="absolute inset-0 overflow-hidden" style={{ width: `${pos}%` }}>
                <img src={beforeAfter.before} alt="Prima" loading="lazy" decoding="async" width="1200" height="800" className="absolute inset-0 h-full object-cover" style={{ width: ref.current ? `${ref.current.getBoundingClientRect().width}px` : '100%' }} />
              </div>
              <div className="absolute top-4 left-4 bg-brand-red text-white text-xs font-bold uppercase px-3 py-1.5 rounded-md tracking-wide shadow-md">Prima</div>
              <div className="absolute top-4 right-4 bg-brand-navy text-white text-xs font-bold uppercase px-3 py-1.5 rounded-md tracking-wide shadow-md">Dopo</div>
              <div className="before-after-handle" style={{ left: `${pos}%` }} />
            </div>
            <p className="text-center text-sm text-gray-500 mt-3 italic">Trascina lo slider per confrontare</p>
          </div>

          <div className="text-center lg:text-left">
            <div className="font-display text-7xl md:text-8xl font-bold text-brand-red leading-none">+100</div>
            <h3 className="font-display text-2xl font-bold text-brand-navy uppercase mt-3">Recensioni Positive</h3>
            <p className="text-gray-600 mt-3 leading-relaxed">Clienti soddisfatti in tutto il Ticino. La nostra reputazione è costruita su lavori fatti con cura e professionalità.</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BeforeAfter;
